//**************************************************************************************************
//*************************************** ResourcesDataService ****************************
//**************************************************************************************************

'use strict';

import {ktAdjustContentToNavbar} from '../0001_directives/angularJS/build/ktdirectives.js';

class ResourcesDataService{

  constructor($http,$q,$rootScope,MessagingService)
  {
   this.cache = {}; //this should go into state manager
    this.$http =$http;
    this.$q = $q;
    this.$rootScope = $rootScope;
    this.MessagingService = MessagingService;
  }
 
   static $inject = ['$http','$q','$rootScope','MessagingService'];
 
    
	  newResourceExecute  (resource) {
       
          var http_method="";
          var url='../api/save-resource-def/';
          
          resource.ResourceDefId.Organisation= 1;
          resource.ResourceDefId.Private= false;
          //resource.ResourceDefId.Status = resource.ResourceDefId.Status.id;
          //resource.ResourceDefId.ResourceType = resource.ResourceDefId.ResourceType.id;
          //resource.CreatedBy = $rootScope.globals.currentUser.userid;
          //resource.ChangedBy = $rootScope.globals.currentUser.userid;
          resource.Lang = this.$rootScope.globals.currentUser.langObj;
          resource.Version= 1;
          resource.ResourceDefId.TableCreated = false;
          resource.ResourceDefId.FormDefined = false;
          
       
         
          http_method="POST";
            var deferred = this.$q.defer();   
          
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: resource
                // data: { 'auction': $scope.auction }
                })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 201 ||status===200) {
                      
                        deferred.resolve({data:data.data,msg:'Resource definition created successfuly !'});
                      
               
                      
                    } else {
                       
                   
                   deferred.reject({msg:"Save failed ! "+data.status+" "+data.data,status:data.status});
                
                  };

                },function (data) {

                    // if error, bind success message to message
                  deferred.reject({msg:"Save failed ! "+data.status+" "+data.data,status:data.status});
                


                });
                return deferred.promise;
        };  
 // NEW MAPPINGS 
     putMappings (name,resourceDefId,mappingsData,fileFields) {
    
          var http_method="POST";                                           
          var url='../api/put-mappings-new/'+resourceDefId+'/';
            var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
                data: {'resourceDefId':resourceDefId,'mappingsData':mappingsData,'name':name,'fileFields':fileFields}
                
            })
                .then(function (data) {
                   // console.log(data);
                    if (data.status === 201) {                                       
                       deferred.resolve({data: data.data,msg:data.msg,status:data.status}); 
                    } else {
                      deferred.reject({msg:'Save failed ! '+data.status+' '+data.data,status:data.status});
                    }
                },function (data) {
                  deferred.reject({msg:'Save failed ! '+data.status+' '+data.data,status:data.status});
                });
                
                 return deferred.promise;
        };

      // UPDATE MAPPINGS 
     putMappingsWithId (name,resourceDefId,id,mappingsData,fileFields) {
    
          var http_method="POST";                                           
          var url='../api/put-mappings/'+resourceDefId+'/'+id+'/';
            var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
                data: {'mappingsId':id,'resourceDefId':resourceDefId,'mappingsData':mappingsData,'name':name,'fileFields':fileFields}
                
            })
                .then(function (data) {
                   // console.log(data);
                    if (data.status === 201) {                                       
                       deferred.resolve({data: data.data,msg:data,status:data.status}); 
                    } else {
                      deferred.reject({msg:'Save failed ! '+data.status+' '+data.data,status:data.status});
                    }
                },function (data) {
                  deferred.reject({msg:'Save failed ! '+data.status+' '+data.data,status:data.status});
                });
                
                 return deferred.promise;
        };       
        
        
     // GET-MAPPINGS LIST
     getMappingsList (resourceDefId) {
    
          var http_method="GET";                                           
          var url='../api/get-mappings-list/'+resourceDefId+'/';
            var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
                data: {'resourceDefId':resourceDefId}
                
            })
                .then(function (data) {
                   // console.log(data);
                    if (data.status === 201) {                                       
                       deferred.resolve({data: data.data,msg:data,status:data.status}); 
                    } else {
                      deferred.reject({msg:'getMappingsList failed ! '+data.status+' '+data.data,status:data.status});
                    }
                },function (data) {
                  deferred.reject({msg:'getMappingsList failed ! '+data.status+' '+data.data,status:data.status});
                });
                
                 return deferred.promise;
        };        
        
        
         // GET-MAPPINGS 
     getMappings (id) {
    
          var http_method="GET";                                           
          var url='../api/get-mappings/'+id+'/';
            var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' }
            })
                .then(function (data) {
                    if (data.status === 201) {                                       
                       deferred.resolve({data: data.data,msg:data,status:data.status}); 
                    } else {
                      deferred.reject({msg:'getMappingsList failed ! '+data.status+' '+data.data,status:data.status});
                    }
                },function (data) {
                  deferred.reject({msg:'getMappingsList failed ! '+data.status+' '+data.data,status:data.status});
                });
                
                 return deferred.promise;
        };        
// MIGOR END
 //********************************************************** http localhost:8080/api/save-resource-def/",
	//           GET RESOURCES DEF  ---------  MIGOR
	
	//**********************************************************      
  getResources  () {
    
          var http_method="GET";
          var url='../api/save-resource-def/';
          var deferred = this.$q.defer(); 
		  
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
            })
                .then(function (data) {
                    // console.log(data);
                    if (data.status === 200) {
                       
                       deferred.resolve({data: data.data,status:data.status});
                    
                    } else {
                   
                      deferred.reject({msg: 'Get failed ! '+data.status+' '+data.data,status:data.status}); 
                    }
                },function (data) {
                    
                     deferred.reject({msg: 'Get failed ! '+data.status+' '+data.data,status:data.status}); 
                

                });
                return deferred.promise;
        };
		
	//**********************************************************
	//           SAVE PAGE DEF
	
	//**********************************************************      
  savePageDef  (page,lang) {
    
          var http_method="POST";
          var url='../api/save-page-def/'+lang+'/';
          var deferred = this.$q.defer(); 
		  
            this.$http({
                method: http_method,
                url: url,
                data : page,
                headers: { 'Content-Type': 'application/json' },
            })
                .then(function (data) {
                    // console.log(data);
                    if (data.status === 200) {
                     deferred.resolve({data: data.data,status:data.status});
                    } else {
                   
                      deferred.reject({msg: data,status:data.status}); 
                    }
                },function (data) {
                    
                     deferred.reject({msg: data,status:data.status}); 
                

                });
                return deferred.promise;
        };
	
  //**********************************************************
	//           SAVE RESOURCES DEF ALL
	
	//**********************************************************      
  saveResourceDefAll  (resource) {
    
          var http_method="PUT";
          var url='../api/resource-def-all/'+resource.id+'/';
          var deferred = this.$q.defer(); 
		  
            this.$http({
                method: http_method,
                url: url,
                data : resource,
                headers: { 'Content-Type': 'application/json' },
            })
                .then(function (data) {
                    // console.log(data);
                    if (data.status === 200) {
                     deferred.resolve({data: data.data,status:data.status});
                    } else {
                   
                      deferred.reject({msg: 'Save failed --> '+data,status:data.status}); 
                    }
                },function (data) {
                    
                     deferred.reject({msg: 'Save failed ! --> '+data,status:data.status}); 
                

                });
                return deferred.promise;
        };
		
    //**********************************************************
	//           SAVE RESOURCES DEF ALL - NEW !!!
	
	//**********************************************************     
          saveResourceDefAllNew  (resource) {
    
          var http_method="PUT";
          var url='../api/resource-def-all-new/'+resource.id+'/';
          var deferred = this.$q.defer(); 
		  
            this.$http({
                method: http_method,
                url: url,
                data : resource,
                headers: { 'Content-Type': 'application/json' },
            })
                .then(function (data) {
                    // console.log(data);
                    if (data.status === 200) {
                     deferred.resolve({data: data.data,status:data.status});
                    } else {
                   
                      deferred.reject({msg: 'Save failed --> '+data,status:data.status}); 
                    }
                },function (data) {
                    
                     deferred.reject({msg: 'Save failed ! --> '+data,status:data.status}); 
                

                });
                return deferred.promise;
        };
    //**********************************************************
	//           SAVE RESOURCES DEF PARAMETERS
	
	//**********************************************************      
  saveResourceDefParameters  (resource_id,parameters) {
    
          var http_method="POST";
          var url='../api/save-resource-def-parameters/'+resource_id+'/';
          var deferred = this.$q.defer(); 
		  
            this.$http({
                method: http_method,
                url: url,
                data : parameters,
                headers: { 'Content-Type': 'application/json' },
            })
                .then(function (data) {
                    // console.log(data);
                    if (data.status === 200) {
                     deferred.resolve({data: data.data,status:data.status});
                    } else {
                   
                      deferred.reject({msg: 'Save failed --> '+data,status:data.status}); 
                    }
                },function (data) {
                    
                     deferred.reject({msg: 'Save failed ! --> '+data,status:data.status}); 
                

                });
                return deferred.promise;
        };
		
    //**********************************************************
	//           SEND NOTIFICATION
	//**********************************************************      
    sendNotification  (notification) {
    
          var http_method="POST";
          var url='../api/send-notification/'+notification.id+'/';
          var deferred = this.$q.defer(); 
		  
            this.$http({
                method: http_method,
                url: url,
                data : notification,
                headers: { 'Content-Type': 'application/json' },
            })
                .then(function (data) {
                    // console.log(data);
                    if (data.status === 200) {
                     deferred.resolve({data: data.data,status:data.status});
                    } else {
                   
                      deferred.reject({msg: 'Send failed --> '+data,status:data.status}); 
                    }
                },function (data) {
                    
                     deferred.reject({msg: 'Send failed ! --> '+data,status:data.status}); 
                

                });
                return deferred.promise;
        };
				
	//********************************************************** 
	//           GET RESOURCES DEF ALL
	
	//**********************************************************      
  getResourceDefAll  (resourceId) {
    
          var http_method="GET";
          var url='../api/resource-def-all/'+resourceId+'/';
          var deferred = this.$q.defer(); 
		  
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
            })
                .then(function (data) {
                    // console.log(data);
                    if (data.status === 200) {
                     deferred.resolve({data: data.data,status:data.status});
                    } else {
                   
                      deferred.reject({msg: 'Get failed ! '+data.status+' '+data.data,status:data.status}); 
                    }
                },function (data) {
                    
                     deferred.reject({msg: 'Get failed ! '+data.status+' '+data.data,status:data.status}); 
                

                });
                return deferred.promise;
        };
		
 //**********************************************************
	//           GET RESOURCE FORM DEFINITION
	//**********************************************************      
  getResourceForm  (resourceId,formType,lang,refresh) {
    
          var http_method="GET";
          
          var url='../api/get-resource-form/'+ resourceId +'/'+formType+'/'+lang+'/';
          var deferred = this.$q.defer();
          
          var gotoServer=false;
      if (this.cache['getResourceForm'] !==undefined && !refresh)
      {
         if(this.cache.getResourceForm[resourceId +'_'+formType+'_'+lang] !==undefined)
         {
            deferred.resolve({data: this.cache.getResourceForm[resourceId +'_'+formType+'_'+lang],status:200});
         }
         else
         {
           this.cache['getResourceForm'][resourceId +'_'+formType+'_'+lang] = {};
           gotoServer=true; 
         }
      } else
      {
         this.cache['getResourceForm'] = {};
         this.cache['getResourceForm'][resourceId +'_'+formType+'_'+lang] = {};
         gotoServer=true;
      }  
      if (gotoServer)
      {
        var instance = this;
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                //data: $scope.dashboard
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                      
                     
                       instance.cache.getResourceForm[resourceId +'_'+formType+'_'+lang] = data.data;
                       deferred.resolve({data: data.data,status:data.status});
                    
                      
                    } else {
                        deferred.reject({msg: 'Get failed ! '+data.status+' '+data.data,status:data.status}); 

                      
                        console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: 'Get failed ! '+data.status+' '+data.data,status:data.status}); 

                });
      }
                return deferred.promise;
        };
   
   
  //**********************************************************
	//           GET RESOURCE MODEL FOR DEPLOYMENT 
	//**********************************************************      
  getResourceModelForDeployment  (resourceId,version,lang) {
    
          var http_method="GET";
          
          var url='../api/get-resource-model-for-deployment/'+ resourceId +'/'+version +'/'+lang+'/';
          var deferred = this.$q.defer();   
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                //data: $scope.dashboard
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                      
                    
                        deferred.resolve({data: data.data,status:data.status});
                   
                      
                    } else {
                        deferred.reject({msg: 'Get resource model failed ! '+data.status+' '+data.data,status:data.status}); 

                      
                        console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: 'Get resource model failed ! '+data.status+' '+data.data,status:data.status}); 

                });
                return deferred.promise;
        };
  //**********************************************************
	//           GET FORM FIELDS
	//**********************************************************      
  getFormFields  (resourceId,lang) {
    
      var http_method="GET";
          
      var url='../api/get-form-fields/'+ resourceId +'/'+lang+'/';
      var deferred = this.$q.defer();
      var gotoServer=false;
           
      if (this.cache['getFormFields'] !==undefined)
      {
         if(this.cache.getFormFields[resourceId+lang] !==undefined)
         {
            deferred.resolve({data:  this.cache.getFormFields[resourceId+lang],status:200});
         }
         else
         {
           this.cache['getFormFields'][resourceId+lang] = {};
           gotoServer=true; 
         }
      } else
      {
         this.cache['getFormFields'] = {};
         this.cache['getFormFields'][resourceId+lang] = {};
         gotoServer=true;
      }  
       if (gotoServer)
       {
          var instance = this;
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                       instance.cache['getFormFields'][resourceId+lang] = data.data;
                        deferred.resolve({data: data.data,status:data.status});
                      
                    } else {
                        deferred.reject({msg: data.data,status:data.status}); 

                      
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: 'GetFormFields failed ! '+data.status+' '+data.data,status:data.status}); 

                });
                
       }
                return deferred.promise;
        };
        //**********************************************************
	//           GET FORM FIELDS BY TYPE
	//**********************************************************      
  getFormFieldsByType  (resourceId,relatedId,elementType,lang) {
    
          var http_method="GET";
          
          var url='../api/get-form-fields-by-type/'+ resourceId +'/'+ relatedId +'/'+elementType+'/'+lang+'/';
          var deferred = this.$q.defer();   
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                       
                        deferred.resolve({data: data.data,status:data.status});
                      
                    } else {
                        deferred.reject({msg: data,status:data.status}); 

                      
                        console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: 'Get failed ! '+data.status+' '+data.data,status:data.status}); 

                });
                return deferred.promise;
        };
  //**********************************************************
	//           GET RESOURCE DATA LIST
	//**********************************************************      
  getResourceDataList  (resourceId,presentationId,lang,search,form,fromCache) {
          
          if (fromCache==undefined)  fromCache=false;
          var http_method="POST";
          if (form==undefined) form=[];
          var url='../api/get-resource-data-list/'+ resourceId +'/'+ presentationId +'/'+lang+'/';
          url = url+'?page=1&page_size=10000';
          var deferred = this.$q.defer();
          var gotoServer=false;
          if (resourceId==undefined || resourceId==null)
          {
           
            deferred.reject({msg: 'Resource id is not defined. Element id = '+presentationId,status:400});  
            
          }
          else{
           

               if (this.cache['getResourceDataList'] !==undefined)
               {
                  if(this.cache.getResourceDataList[resourceId+'_'+presentationId+lang] !==undefined)
                  {
                     if (this.cache.getResourceDataList[resourceId+'_'+presentationId+lang].downloaded && (search==="" || search=={} || search==[{}] || fromCache))
                     deferred.resolve({data:  this.cache.getResourceDataList[resourceId+'_'+presentationId+lang].data,status:200});
                  }
                  else
                  {
                    this.cache['getResourceDataList'][resourceId+'_'+presentationId+lang] = {data:[],downloaded:false};
                    gotoServer=true; 
                  }
               } else
               {
                  this.cache['getResourceDataList'] = {};
                  this.cache['getResourceDataList'][resourceId+'_'+presentationId+lang] = {data:[],downloaded:false};
                  gotoServer=true;
               }
               
              
               if (search!=="")
               {
                  gotoServer=true;
               }
          }
          if (gotoServer)
          {
          
            var instance = this;
           
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
                data:  {'filter':search,'form':form},
                //data: {'id__in':[2]},
               })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                        if (search ==="" || search=={} || search==[{}] || fromCache)
                        {
                            instance.cache['getResourceDataList'][resourceId+'_'+presentationId+lang].data = data.data;
                            instance.cache['getResourceDataList'][resourceId+'_'+presentationId+lang].downloaded = true;
                            
                        }
                        deferred.resolve({data: data.data,status:data.status});
                      
                    } else {
                        deferred.reject({msg: data,status:data.status}); 

                      
                       // console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: data,status:data.status}); 

                });
          }
         
                return deferred.promise;
        };

         //**********************************************************
	//           GET RESOURCE DATA LIST ALL
	//**********************************************************      
  getResourceDataListAll  (resourceId,presentationId,lang,fromCache,callback) {
          
          if (fromCache==undefined)  fromCache=false;
          var http_method="GET";
          var url='../api/get-resource-data-list-all/'+ resourceId +'/'+ presentationId +'/'+lang+'/';
          var deferred = this.$q.defer();
          var gotoServer=false;
          if (resourceId==undefined || resourceId==null)
          {
           
            deferred.reject({msg: 'Resource id is not defined. Element id = '+presentationId,status:400});  
            
          }
          else{
           

               if (this.cache['getResourceDataListAll'] !==undefined)
               {
                  if(this.cache.getResourceDataListAll[resourceId+'_'+lang] !==undefined)
                  {
                     if (this.cache.getResourceDataListAll[resourceId+'_'+lang].downloaded && fromCache)
                     deferred.resolve({data:  this.cache.getResourceDataListAll[resourceId+'_'+lang].data,status:200});
                     else if (this.cache.getResourceDataListAll[resourceId+'_'+lang].downloadInProgress)
                     {
                        if (this.cache.getResourceDataListAll[resourceId+'_'+lang].callBacks == undefined) this.cache.getResourceDataListAll[resourceId+'_'+lang].callBacks = [];
                        
                        this.cache.getResourceDataListAll[resourceId+'_'+lang].callBacks.push(callback); 
                     }
                  }
                  else
                  {
                    this.cache['getResourceDataListAll'][resourceId+'_'+lang] = {data:[],downloaded:false,downloadInProgress:true};
                    gotoServer=true; 
                  }
               } else
               {
                  this.cache['getResourceDataListAll'] = {};
                  this.cache['getResourceDataListAll'][resourceId+'_'+lang] = {data:[],downloaded:false,downloadInProgress:true};
                  gotoServer=true;
               }
               
              
          }
          if (gotoServer)
          {
          
            var instance = this;
            if (this.cache.getResourceDataListAll[resourceId+'_'+lang].callBacks==undefined) this.cache.getResourceDataListAll[resourceId+'_'+lang].callBacks = [];
                            
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
               // data:  {'filter':search,'form':form},
                //data: {'id__in':[2]},
               })
                .then(function (data) {
                    // console.log(data);
                    
                    if (instance.cache.getResourceDataListAll[resourceId+'_'+lang].callBacks==undefined) instance.cache.getResourceDataListAll[resourceId+'_'+lang].callBacks = [];
                            
                    if (data.status === 200) {
                        
                            instance.cache['getResourceDataListAll'][resourceId+'_'+lang].data = data.data;
                            instance.cache['getResourceDataListAll'][resourceId+'_'+lang].downloaded = true;
                             //send callback to inform data is available
                            for (let i=0;i< instance.cache.getResourceDataListAll[resourceId+'_'+lang].callBacks.length;i++)
                            {
                                instance.cache.getResourceDataListAll[resourceId+'_'+lang].callBacks[i]();
                        
                            }
                           
                            instance.cache.getResourceDataListAll[resourceId+'_'+lang].callBacks=[];
                            instance.cache.getResourceDataListAll[resourceId+'_'+lang].downloadInProgress=false;
                            deferred.resolve({data: data.data,status:data.status});
                      
                    } else {
                        
                        instance.cache.getResourceDataListAll[resourceId+'_'+lang].downloadInProgress=false;
                        deferred.reject({msg: data.data,status:data.status}); 
                       // console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                    instance.cache.getResourceDataListAll[resourceId+'_'+lang].downloadInProgress=false;
                    deferred.reject({msg: data.data,status:data.status}); 

                });
          }
         
                return deferred.promise;
        };
        
        
     //**********************************************************
	//           GET RESOURCE DATA PANDAS 
	//**********************************************************      
  getResourceDataPandas  (resourceId,presentationId,lang,fromCache,callback) {
          
          if (fromCache==undefined)  fromCache=false;
          var http_method="GET";
          var url='../api/get-resource-data-pandas/'+ resourceId +'/'+ presentationId +'/'+lang+'/';
          var deferred = this.$q.defer();
          var gotoServer=false;
          //debugger
          
          if (resourceId==undefined || resourceId==null) {
            deferred.reject({msg: 'Resource id is not defined. Element id = '+presentationId,status:400});    
          }
          else {
               if (this.cache['getResourceDataPandas'] !==undefined)
               {
                  if(this.cache.getResourceDataPandas[resourceId+'_'+lang] !==undefined)
                  {
                     if (this.cache.getResourceDataPandas[resourceId+'_'+lang].downloaded && fromCache)    deferred.resolve({data:  this.cache.getResourceDataPandas[resourceId+'_'+lang].data,status:200});
                     else if (this.cache.getResourceDataPandas[resourceId+'_'+lang].downloadInProgress)
                     {
                        if (this.cache.getResourceDataPandas[resourceId+'_'+lang].callBacks == undefined) this.cache.getResourceDataPandas[resourceId+'_'+lang].callBacks = [];
                        this.cache.getResourceDataPandas[resourceId+'_'+lang].callBacks.push(callback); 
                     }
                  }
                  else
                  {
                    this.cache['getResourceDataPandas'][resourceId+'_'+lang] = {data:[],downloaded:false,downloadInProgress:true};
                    gotoServer=true; 
                  }
               } else {
                  this.cache['getResourceDataPandas'] = {};
                  this.cache['getResourceDataPandas'][resourceId+'_'+lang] = {data:[],downloaded:false,downloadInProgress:true};
                  gotoServer=true;
               }
            }
          if (gotoServer) {
          
            var instance = this;
            if (this.cache.getResourceDataPandas[resourceId+'_'+lang].callBacks==undefined) this.cache.getResourceDataPandas[resourceId+'_'+lang].callBacks = [];
                            
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
               // data:  {'filter':search,'form':form},
                data: {'id__in':[2]},
               })
                .then(function (data) {
                     console.log(data);
                    
                    if (instance.cache.getResourceDataPandas[resourceId+'_'+lang].callBacks==undefined) instance.cache.getResourceDataPandas[resourceId+'_'+lang].callBacks = [];
                            
                    if (data.status === 200) {
                        
                            instance.cache['getResourceDataPandas'][resourceId+'_'+lang].data = data.data;
                            instance.cache['getResourceDataPandas'][resourceId+'_'+lang].downloaded = true;
                             //send callback to inform data is available
                            for (let i=0;i< instance.cache.getResourceDataPandas[resourceId+'_'+lang].callBacks.length;i++) {
                                instance.cache.getResourceDataPandas[resourceId+'_'+lang].callBacks[i]();
                            }
                           
                            instance.cache.getResourceDataPandas[resourceId+'_'+lang].callBacks=[];
                            instance.cache.getResourceDataPandas[resourceId+'_'+lang].downloadInProgress=false;
                            deferred.resolve({data: data.data,status:data.status});
                      
                    } else {
                        instance.cache.getResourceDataPandas[resourceId+'_'+lang].downloadInProgress=false;
                        deferred.reject({msg: data.data,status:data.status}); 
                       // console.log(data);
                    }
                },function (data) {
                    // if error, bind success message to message
                    instance.cache.getResourceDataPandas[resourceId+'_'+lang].downloadInProgress=false;
                    deferred.reject({msg: data.data,status:data.status}); 

                });
          }
         
                return deferred.promise;
        };
        
        
  //**********************************************************
	//           GET RESOURCE FORM DEFINITION
	//**********************************************************      
  getResourceFormWithData  (resourceDefId,resourceId,formType,lang) {
    
          var http_method="GET";
          
          var url='../api/get-resource-form-with-data/'+ resourceDefId +'/'+ resourceId +'/'+formType+'/'+lang+'/';
          var deferred = this.$q.defer();   
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                //data: $scope.dashboard
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                      
                      //if (data.widgets.length>0) {
                        //code
                       
                        deferred.resolve({data: data.data,status:data.status});
                       //}
                     
                       
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                      
                    } else {
                        deferred.reject({msg: 'Get failed ! '+data.status+' '+data.data,status:data.status}); 

                      
                        console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: 'Get failed ! '+data.status+' '+data.data,status:data.status}); 

                });
                return deferred.promise;
        };
  //**********************************************************
	//           GET RESOURCE FORM EXTENDED
	//**********************************************************      
  getResourceFormExtended  (resourceId,taskDefId,formType,parentId,overrideType,lang) {
    
      var http_method="GET";
          
      var url='../api/get-resource-form-extended/'+ resourceId +'/'+taskDefId+'/'+formType+'/'+parentId+'/'+overrideType+'/'+lang+'/';
      var deferred = this.$q.defer();
     
     /*
      * var gotoServer=false;
      if (this.cache['getResourceFormExtended'] !==undefined)
      {
         if(this.cache.getResourceFormExtended[resourceId +'_'+taskDefId+'_'+formType+'_'+parentId+'_'+overrideType+'_'+lang] !==undefined)
         {
            deferred.resolve({data: this.cache.getResourceFormExtended[resourceId +'_'+taskDefId+'_'+formType+'_'+parentId+'_'+overrideType+'_'+lang],status:200});
         }
         else
         {
           this.cache['getResourceFormExtended'][resourceId +'_'+taskDefId+'_'+formType+'_'+parentId+'_'+overrideType+'_'+lang] = {};
           gotoServer=true; 
         }
      } else
      {
         this.cache['getResourceFormExtended'] = {};
         this.cache['getResourceFormExtended'][resourceId +'_'+taskDefId+'_'+formType+'_'+parentId+'_'+overrideType+'_'+lang] = {};
         gotoServer=true;
      }  
       if (gotoServer)
       {*/
          
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                //data: $scope.dashboard
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                      
                    // this.cache['getResourceFormExtended'][resourceId +'_'+taskDefId+'_'+formType+'_'+parentId+'_'+overrideType+'_'+lang] = data;
                     deferred.resolve({data: data.data,status:data.status});
                     
                    } else {
                        deferred.reject({msg: 'Get failed ! '+data.status+' '+data.data,status:data.status}); 

                      
                        console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: 'Get failed ! '+data.status+' '+data.data,status:data.status}); 

                });
      //   }
                return deferred.promise;
   };
    //**********************************************************
	//           GET RESOURCE FORM EXTENDED WITh DATA
	//**********************************************************  
  getResourceFormExtendedWithData  (resourceId,taskInitiateId,taskExecuteId,populateType,parentId,parentInitiateId,prevTaskExeId,formType,widgetType,resourceRecordId,overrideType,lang) {
    
          
         
          var http_method="GET";
          //debugger  getResourceFormExtendedWithData(resourceId,taskInitiateId,taskExecuteId,populateType,parentId,parentInitiateId,prevTaskExeId,formType,widgetType,resourceRecordId,overrideType,lang) {
          var url='../api/get-resource-form-extended-with-data/'+ resourceId +'/'+taskInitiateId+'/'+taskExecuteId+'/'+populateType+'/'+parentId+'/'+parentInitiateId+'/'+prevTaskExeId+'/'+formType+'/'+widgetType+'/'+resourceRecordId+'/'+overrideType+'/'+lang+'/';
          var deferred = this.$q.defer();
          
          if (resourceId ==null || resourceId ==undefined)
          {
            deferred.reject({msg:"Invalid API params in function ResourceDataService.getResourceFormExtendedWithData --> resourceId is null or undefined",status:400}); 
            var gotoServer=false;
          }
       
       /*  var gotoServer=false;
         if (this.cache['getResourceFormExtendedWithData'] !==undefined)
         {
            if(this.cache.getResourceFormExtendedWithData[resourceId +'_'+taskInitiateId+'_'+taskExecuteId+'_'+populateType+'_'+parentId+'_'+parentInitiateId+'_'+prevTaskExeId+'_'+formType+'_'+widgetType+'_'+resourceRecordId+'_'+overrideType+'_'+lang] !==undefined)
            {
               deferred.resolve({data: this.cache.getResourceFormExtendedWithData[resourceId +'_'+taskInitiateId+'_'+taskExecuteId+'_'+populateType+'_'+parentId+'_'+parentInitiateId+'_'+prevTaskExeId+'_'+formType+'_'+widgetType+'_'+resourceRecordId+'_'+overrideType+'_'+lang],status:200});
            }
            else
            {
              this.cache['getResourceFormExtendedWithData'][resourceId +'_'+taskInitiateId+'_'+taskExecuteId+'_'+populateType+'_'+parentId+'_'+parentInitiateId+'_'+prevTaskExeId+'_'+formType+'_'+widgetType+'_'+resourceRecordId+'_'+overrideType+'_'+lang] = {};
              gotoServer=true; 
            }
         } else
         {
            this.cache['getResourceFormExtendedWithData'] = {};
            this.cache['getResourceFormExtendedWithData'][resourceId +'_'+taskInitiateId+'_'+taskExecuteId+'_'+populateType+'_'+parentId+'_'+parentInitiateId+'_'+prevTaskExeId+'_'+formType+'_'+widgetType+'_'+resourceRecordId+'_'+overrideType+'_'+lang] = {};
            gotoServer=true;
         }  
          if (gotoServer)
          {*/
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

            })
                .then(function (data) {

                    if (data.status === 200) {
                      
                    // this.cache['getResourceFormExtendedWithData'][resourceId +'_'+taskInitiateId+'_'+taskExecuteId+'_'+populateType+'_'+parentId+'_'+parentInitiateId+'_'+prevTaskExeId+'_'+formType+'_'+widgetType+'_'+resourceRecordId+'_'+overrideType+'_'+lang] = data;
                     deferred.resolve({data: data.data,status:data.status});
                      
                 
                    } else {
                        deferred.reject({msg: data.msg,status:data.status}); 

                      }
                },function (data) {

                    // if error, bind success message to message
                    var msg="";
                    if (data.msg!=undefined) {
                      msg = data.msg;
                    }else msg = data;
                    
                   deferred.reject({msg:msg,status:data.status}); 

                });
         
               
          //}
          
          return deferred.promise;
        };
   //**********************************************************
	//           GET RESOURCE FORM EXTENDED MULTIPLE
	//**********************************************************      
  getResourceFormExtendedMultiple  (resourceId,taskDefId,formType,parentId,overrideTypes,lang) {
    
          var http_method="POST";
          
          var url='../api/get-resource-form-extended-multiple/'+ resourceId +'/'+taskDefId+'/'+formType+'/'+parentId+'/'+lang+'/';
          var deferred = this.$q.defer();   
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: overrideTypes
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                      
                      //if (data.widgets.length>0) {
                        //code
                       
                        deferred.resolve({data: data.data,status:data.status});
                       //}
                     
                       
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                      
                    } else {
                        deferred.reject({msg: 'Get resource form multiple failed ! '+data.status+' '+data.data,status:data.status}); 

                      
                        console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: 'Get resource form multiple failed ! '+data.status+' '+data.data,status:data.status}); 

                });
                return deferred.promise;
        };           
   //**********************************************************
	//           GET RESOURCE FORM EXTENDED MULTIPLE
	//**********************************************************      
  getResourceFormExtendedWithDataMultiple (resourceId,taskInitiateId,taskExecuteId,populateType,parentId,parentInitiateId,prevTaskExeId,formType,widgetType,resourceRecordIds,overrideType,filter,parentDatasetDefId,rmdId,lang) {
    
          var http_method="POST";
          //debugger
          var url='../api/get-resource-form-extended-with-data-multiple/'+ resourceId +'/'+taskInitiateId+'/'+taskExecuteId+'/'+populateType+'/'+parentId+'/'+parentInitiateId+'/'+prevTaskExeId+'/'+formType+'/'+widgetType+'/'+resourceRecordIds+'/'+overrideType+'/'+parentDatasetDefId+'/'+rmdId+'/'+lang+'/';
          var deferred = this.$q.defer();   
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: filter
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                      
                      //if (data.widgets.length>0) {
                        //code
                       
                        deferred.resolve({data: data.data,status:data.status});
                       //}
                     
                       
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                      
                    } else {
                        deferred.reject({msg: 'Get resource form multiple failed ! '+data.status+' '+data.data,status:data.status}); 

                      
                        console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: 'Get resource form multiple failed ! '+data.status+' '+data.data,status:data.status}); 

                });
                return deferred.promise;
        };           
  
   //**********************************************************
	//           GET RESOURCE FORM EXTENDED MULTIPLE
	//**********************************************************      
 getResourceFormAddMultiple (resourceId,taskInitiateId,taskExecuteId,parentId,parentInitiateId,prevTaskExeId,formType,widgetType,overrideType,filter,lang) {
    
          var http_method="POST";
          
          var url='../api/get-resource-form-add-multiple/'+ resourceId +'/'+taskInitiateId+'/'+taskExecuteId+'/'+parentId+'/'+parentInitiateId+'/'+prevTaskExeId+'/'+formType+'/'+widgetType+'/'+overrideType+'/'+lang+'/';
          var deferred = this.$q.defer();   
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: filter
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                      
                      //if (data.widgets.length>0) {
                        //code
                       
                        deferred.resolve({data: data.data,status:data.status});
                       //}
                     
                       
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                      
                    } else {
                        deferred.reject({msg: 'Get resource form multiple failed ! '+data.status+' '+data.data,status:data.status}); 

                      
                        console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: 'Get resource form multiple failed ! '+data.status+' '+data.data,status:data.status}); 

                });
                return deferred.promise;
        };           
  //**********************************************************
	//           SAVE DATASET RECORDS MULTIPLE
	//**********************************************************      
  saveDatasetRecordsMultiple  (resourceId,form) {
    
          var http_method="POST";
          
          var url='../api/save-dataset-records-multiple/'+ resourceId +'/';
          var deferred = this.$q.defer();   
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: form
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                      
                      //if (data.widgets.length>0) {
                        //code
                       
                        deferred.resolve({msg: data,status:data.status});
                       //}
                     
                       
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                      
                    } else {
                        deferred.reject({msg: data,status:data.status}); 

                      
                       // console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: data,status:data.status}); 

                });
                return deferred.promise;
        };           
  
  //**********************************************************
	//           GET RESOURCE DEFINITION LIST
	//**********************************************************          
 getResourceDef (lang){
      
      
       var deferred = this.$q.defer();
       
        var gotoServer=false;
      if (this.cache['getResourceDef'] !==undefined)
      {
         if(this.cache.getResourceDef[lang] !==undefined)
         {
            deferred.resolve({data:  this.cache.getResourceDef[lang],status:200});
         }
         else
         {
           this.cache['getResourceDef'][lang] = {};
           gotoServer=true; 
         }
      } else
      {
         this.cache['getResourceDef'] = {};
         this.cache['getResourceDef'][lang] = {};
         gotoServer=true;
      }  
      if (gotoServer)
      { 
       var instance = this;
       this.$http({
                method: 'GET',
                url: '../api/get-resource-def-bylang/'+lang+'/',
                headers: { 'Content-Type': 'application/json' },

                //data: $scope.CodeHeadLang
               
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    instance.cache.getResourceDef[lang] = data.data;
                    deferred.resolve({data: data.data,status:data.status});
                   
                   
                    } else {
                      
                        // if not successful, bind errors to error variables
                
                      deferred.reject({msg: 'Download failed --> getResourceDef! '+data.status+' '+data.data,status:data.status}); 
                        
                    }
                },function (data) {

                   // if not successful, bind errors to error variables
                    deferred.reject({msg: 'Download failed --> getResourceDef ! '+data.status+' '+data.data,status:data.status}); 
                   
                });
      }     
                 return deferred.promise;
    }
    
  //**********************************************************
	//           GET RESOURCE DEFINITION LIST
	//**********************************************************          
 getResourceDefFiltered (new_page,page_size,filter,lang){
      
      var http_method="POST";
                  
          var url='../api/get-resource-def-bylang-filtered/'+lang+'/';
          //url='https://dev.katalyo.com/api/get-resource-def-bylang-filtered/'+lang+'/';
          if (new_page!="" && new_page!=undefined)
          {
            url = url+'?page='+new_page;
            if (page_size!="" && page_size!=undefined)
            {
            url = url+'&page_size='+page_size;
            
            }
          }
          
       var deferred = this.$q.defer();   
       this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: filter
               
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                    deferred.resolve({data: data.data,status:data.status});
                   
                    
                    } else {
                      
                        // if not successful, bind errors to error variables
                     
                      deferred.reject({msg: 'Download failed --> getResourceDefFiltered! '+data.status+' '+data.data,status:data.status}); 
                   
                 
                        
                    }
                },function (data) {

                   // if not successful, bind errors to error variables
                    deferred.reject({msg: 'Download failed --> getResourceDefFiltered! '+data.status+' '+data.data,status:data.status}); 
                   
                });
                
                 return deferred.promise;
    }
             
  //**********************************************************
	//           GET RESOURCE DEFINITION LIST BY TYPE
	//**********************************************************          
 getResourceDefByType (lang,type){
      
      
      var deferred = this.$q.defer();   
      var gotoServer=false;
      if (this.cache['getResourceDefByType'] !==undefined)
      {
         if(this.cache.getResourceDefByType[lang+type] !==undefined)
         {
            deferred.resolve({data:  this.cache.getResourceDefByType[lang+type],status:200});
         }
         else
         {
           this.cache['getResourceDefByType'][lang+type] = {};
           gotoServer=true; 
         }
      } else
      {
         this.cache['getResourceDefByType'] = {};
         this.cache['getResourceDefByType'][lang+type] = {};
         gotoServer=true;
      }  
      if (gotoServer)
      { 
         var instance = this; 
         this.$http({
                method: 'GET',
                url: '../api/get-resource-def-bylang-bytype/'+lang+'/'+type+'/',
                headers: { 'Content-Type': 'application/json' },

                //data: $scope.CodeHeadLang
               
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    instance.cache['getResourceDefByType'][lang+type] = data.data;
                    deferred.resolve({data: data.data,status:data.status});
                  
                    } else {
                      
                    deferred.reject({msg: 'Download failed --> getResourceDefByType! '+data.status+' '+data.data,status:data.status}); 
                   
                       
                        
                    }
                },function (data) {

                    deferred.reject({msg: 'Download failed --> getResourceDefByType ! '+data.status+' '+data.data,status:data.status}); 
                   
                });
      }          
                 return deferred.promise;
    };
     //**********************************************************
	//           GET RESOURCE DEFINITION BY TYPE PAGINATED
	//**********************************************************          
 getResourceDefByLangByTypePaginated (lang,type,url_next,url_prev,new_page,page_size){
          
          var url = '../api/get-resource-def-bylang-bytype-paginated/'+lang+'/'+type+'/';
          if (new_page!="" && new_page!=undefined)
          {
            url = url+'?page='+new_page;
            if (page_size!="" && page_size!=undefined)
            {
            url = url+'&page_size='+page_size;
            
            }
          }
          
       var deferred = this.$q.defer();   
       this.$http({
                method: 'GET',
                url: url,
                headers: { 'Content-Type': 'application/json' },

                //data: $scope.CodeHeadLang
               
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                    deferred.resolve({data: data.data,status:data.status});
                   
                    
                    } else {
                      
                    deferred.reject({msg: 'Download failed --> getResourceDefByLangByTypePaginated! '+data.status+' '+data.data,status:data.status}); 
                   
                       
                        
                    }
                },function (data) {

                    deferred.reject({msg: 'Download failed --> getResourceDefByLangByTypePaginated! '+data.status+' '+data.data,status:data.status}); 
                   
                });
                
                 return deferred.promise;
    }
    
 //**********************************************************
	//           GET RELATED DATASET FOR Widget
	//**********************************************************
  getRelatedDatasetForWidget(datasetId,lang){
 
  var deferred = this.$q.defer();   
       this.$http({
                method: 'GET',
                url: '../api/get-related-dataset-forwidget/'+datasetId+'/'+lang+'/',
                headers: { 'Content-Type': 'application/json' },

                //data: $scope.CodeHeadLang
               
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                    deferred.resolve({data: data.data,status:data.status});
                   
                                    
                    // });
                    } else {
                      
                    deferred.reject({msg: 'Related Dataset definition download error ! '+data.status+' '+data.data,status:data.status}); 
                   
                       
                        
                    }
                },function (data) {

                    deferred.reject({msg: 'Resource definition download error ! '+data.status+' '+data.data,status:data.status}); 
                   
                });
                
                 return deferred.promise;
 
 }
  
  //**********************************************************
	//           GET RESOURCE DEFINITION LIST BY TYPE
	//**********************************************************
 getResourceDefByTypeForWidget (lang,type){
      
      
       var deferred = this.$q.defer();   
       this.$http({
                method: 'GET',
                url: '../api/get-resource-def-bytype-forwidget/'+lang+'/'+type+'/',
                headers: { 'Content-Type': 'application/json' },

                //data: $scope.CodeHeadLang
               
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                    deferred.resolve({data: data.data,status:data.status});
                   
                                    
                    // });
                    } else {
                      
                    deferred.reject({msg: 'Resource definition download error ! '+data.status+' '+data.data,status:data.status}); 
                   
                       
                        
                    }
                },function (data) {

                    deferred.reject({msg: 'Resource definition download error ! '+data.status+' '+data.data,status:data.status}); 
                   
                });
                
                 return deferred.promise;
    } 
 //**********************************************************
	//           GET RESOURCE DEFINITION LIST BY TYPE FOR DROPDOWN
	//**********************************************************          
 getResourceDefListByType (lang,type){
   
      var deferred = this.$q.defer();  
      var gotoServer=false;
      if (this.cache['getResourceDefListByType'] !==undefined)
      {
         if(this.cache.getResourceDefListByType[lang+type] !==undefined)
         {
            deferred.resolve({data:  this.cache.getResourceDefListByType[lang+type],status:200});
         }
         else
         {
           this.cache['getResourceDefListByType'][lang+type] = [];
           gotoServer=true; 
         }
      } else
      {
         this.cache['getResourceDefListByType'] = {};
         this.cache['getResourceDefListByType'][lang+type] = [];
         gotoServer=true;
      }  
       if (gotoServer)
       {
          var instance = this;
          this.$http({
                method: 'GET',
                url: '../api/get-resource-def-list-bylang-bytype/'+lang+'/'+type+'/',
                headers: { 'Content-Type': 'application/json' },

                //data: $scope.CodeHeadLang
               
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                   instance.cache['getResourceDefListByType'][lang+type] = data.data;
                    deferred.resolve({data: data.data,status:data.status});
                   
                   
                    } else {
                      
                    deferred.reject({msg: 'Download failed --> getResourceDefListByType! '+data.status+' '+data.data,status:data.status}); 
                   
                       
                        
                    }
                },function (data) {

                    deferred.reject({msg: 'Download failed --> getResourceDefListByType! '+data.status+' '+data.data,status:data.status}); 
                   
                });
       }
                 return deferred.promise;
    }

//**********************************************************
	//           GET RESOURCE DEFINITION LIST BY TYPE WITH FILTER FOR DROPDOWN
	//**********************************************************          
 getResourceDefListByTypeFilter (lang,type,search,selectedResource){
      
      
       var deferred = this.$q.defer();
        var gotoServer=false;
          if (selectedResource==undefined || selectedResource==null)
          {
           
            deferred.reject({msg: 'Resource is not defined!',status:400});  
            
          }
          else{
           

               if (this.cache['getResourceDefListByTypeFilter'] !==undefined)
               {
                  if(this.cache.getResourceDefListByTypeFilter[lang+'_'+type+'_'+selectedResource] !==undefined && (search==="" || search===undefined))
                  {
                     deferred.resolve({data:  this.cache.getResourceDefListByTypeFilter[lang+'_'+type+'_'+selectedResource],status:200});
                  }
                  else
                  {
                    this.cache['getResourceDefListByTypeFilter'][lang+'_'+type+'_'+selectedResource] = {};
                    gotoServer=true; 
                  }
               } else
               {
                  this.cache['getResourceDefListByTypeFilter'] = {};
                  this.cache['getResourceDefListByTypeFilter'][lang+'_'+type+'_'+selectedResource] = {};
                  gotoServer=true;
               }
               
              
               if (search!=="" && search!==undefined)
               {
                  gotoServer=true;
               }
          }
          if (gotoServer)
          {
             var instance = this;
            this.$http({
                method: 'POST',
                url: '../api/get-resource-def-list-bylang-bytype-filter/'+lang+'/'+type+'/'+selectedResource+'/',
                headers: { 'Content-Type': 'application/json' },

                data: {'search':search}
               
            })
            .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                     instance.cache['getResourceDefListByTypeFilter'][lang+'_'+type+'_'+selectedResource] = data.data;
                     deferred.resolve({data: data.data,status:data.status});
                   
                    } else {
                      
                    deferred.reject({msg: 'Dataset downloand failed ! '+data.status+' '+data.data,status:data.status}); 
                   
                       
                        
                    }
            },function (data) {

                    deferred.reject({msg: 'Dataset download failed ! '+data.status+' '+data.data,status:data.status}); 
                   
            });
          }    
                 return deferred.promise;
    }
    
                         
                                          
  //**********************************************************
	//           GET RESOURCE DEFINITION LIST BY TYPE AND USER
	//**********************************************************          
 getResourceDefListByLangByTypeUser (lang,type,user){
      
      
       var deferred = this.$q.defer();   
       this.$http({
                method: 'GET',
                url: '../api/get-resource-def-list-bylang-bytype-user/'+lang+'/'+type+'/'+user+'/',
                headers: { 'Content-Type': 'application/json' },

                //data: $scope.CodeHeadLang
               
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                    deferred.resolve({data: data.data,status:data.status});
                   
                    
                    } else {
                      
                       deferred.reject({msg: 'Download failed --> getResourceDefListByLangByTypeUser! '+data.status+' '+data.data,status:data.status}); 
                   
                        
                    }
                },function (data) {

                   deferred.reject({msg: 'Download failed --> getResourceDefListByLangByTypeUser! '+data.status+' '+data.data,status:data.status}); 
                   

                });
                
                 return deferred.promise;
    }    
   
    //************************************************************************************//
    //************************************************************************************//
	//           Blockchain API calls
	//************************************************************************************//
    //***********************************************************************************//
    //**********************************************************
	//           getBlockchainDatasetRecords
	//**********************************************************          
 getBlockchainDatasetRecords (dataset_id,dataset_name,contract,limit,p_key,lang){
      
        let url='../api/get-blockchain-dataset-records/';
       
        let post_data = {"resource_id":dataset_id,"dataset":dataset_name,"contract":contract,"limit":limit,"p_key":p_key,"language":lang}  
        let deferred = this.$q.defer();   
        this.$http({
                method: 'POST',
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: post_data
               
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                    deferred.resolve({data: data.data,status:data.status});
                   
                    
                    } else {
                      
                       deferred.reject({msg: 'Error --> getBlockchainDatasetRecords! '+data.status+' '+data.data,status:data.status}); 
                   
                        
                    }
                },function (data) {

                   deferred.reject({msg: 'Error --> getBlockchainDatasetRecords! '+data.status+' '+data.data,status:data.status}); 
                   

                });
                
                 return deferred.promise;
    }
  
    //**********************************************************
	//           getBlockchainDatasetRecords
	//**********************************************************          
 executeBlockchainFunction (contract,function_name,params){
      
        let url='../api/execute-blockchain-function/';
       
        let post_data = {"contract":contract,"function":function_name,"params":params}  
        let deferred = this.$q.defer();   
        this.$http({
                method: 'POST',
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: post_data
               
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                    deferred.resolve({data: data.data,status:data.status});
                   
                    
                    } else {
                      
                       deferred.reject({msg: 'Error --> executeBlockchainDatasetRecords! '+data.status+' '+data.data,status:data.status}); 
                   
                        
                    }
                },function (data) {

                   deferred.reject({msg: 'Error --> executeBlockchainDatasetRecords! '+data.status+' '+data.data,status:data.status}); 
                   

                });
                
                 return deferred.promise;
    }
  
    
      //**********************************************************
	//           getBlockchainDatasetRecords
	//**********************************************************          
 getBlockchainTransaction (transaction_id,block_num_hint){
      
        let url='../api/get-blockchain-transaction/';
       
        let post_data = {"transaction_id":transaction_id,"block_num_hint":block_num_hint}  
        let deferred = this.$q.defer();   
        this.$http({
                method: 'POST',
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: post_data
               
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                    deferred.resolve({data: data.data,status:data.status});
                   
                    
                    } else {
                      
                       deferred.reject({msg: 'Error --> getBlockchainTransaction! '+data.status+' '+data.data,status:data.status}); 
                   
                        
                    }
                },function (data) {

                   deferred.reject({msg: 'Error --> getBlockchainTransaction! '+data.status+' '+data.data,status:data.status}); 
                   

                });
                
                 return deferred.promise;
    }    
      //**********************************************************
	//           readBlockchainContractPublicVars
	//**********************************************************          
 readBlockchainVars (contract,abi){
      
        let url='../api/get-contract-public-vars/';
       
        let post_data = {"contract":contract,"abi":abi}  
        let deferred = this.$q.defer();   
        this.$http({
                method: 'POST',
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: post_data
               
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                    deferred.resolve({data: data.data,status:data.status});
                   
                    
                    } else {
                      
                       deferred.reject({msg: 'Error --> readBlockchainVars! '+data.status+' '+data.data,status:data.status}); 
                   
                        
                    }
                },function (data) {

                   deferred.reject({msg: 'Error --> readBlockchainVars! '+data.status+' '+data.data,status:data.status}); 
                   

                });
                
                 return deferred.promise;
    }
   //**********************************************************
	//           GET RESOURCE DEFINITION LIST BY TYPE AND USER
	//**********************************************************          
 getResourceDefByLangByTypeUserPaginated (lang,type,url_next,url_prev,new_page,page_size){
      
      var url='../api/get-resource-def-bylang-bytype-user/'+lang+'/'+type+'/';
       if (new_page!="" && new_page!=undefined)
          {
            url = url+'?page='+new_page;
            if (page_size!="" && page_size!=undefined)
            {
            url = url+'&page_size='+page_size;
            
            }
          }
          
       var deferred = this.$q.defer();   
       this.$http({
                method: 'GET',
                url: url,
                headers: { 'Content-Type': 'application/json' },

                //data: $scope.CodeHeadLang
               
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                    deferred.resolve({data: data.data,status:data.status});
                   
                    
                    } else {
                      
                       deferred.reject({msg: 'Download failed --> getResourceDefByLangByTypeUserPaginated! '+data.status+' '+data.data,status:data.status}); 
                   
                        
                    }
                },function (data) {

                   deferred.reject({msg: 'Download failed --> getResourceDefByLangByTypeUserPaginated! '+data.status+' '+data.data,status:data.status}); 
                   

                });
                
                 return deferred.promise;
    }    
   
  //**********************************************************
	//           SYNC DATABASE - CREATE OR ALTER TABLE
	//**********************************************************      
  syncdb  (resourceId,version,resource_type) {
    
          var http_method="POST";
          
          var url='../api/syncdb-resource-form/'+resourceId+'/'+version+'/'+resource_type+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                       deferred.resolve({msg: 'Database synchronisation successful !',status:data.status});

                    } else {
                      
                   
                     deferred.reject({msg: 'Database synchronisation failed! '+data.data,status:data.status});
                 //  $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
             
                    }
                },function (data) {

                    deferred.reject({msg: 'Database synchronisation failed! '+data.data,status:data.status});

                });
                   return deferred.promise;
        };
         //**********************************************************
	//           SAVE RESOURCE FORM 
	//**********************************************************          
        saveResourceForm  (widgets,resourceId,formType) {
    
            var http_method="POST";
            var lang=this.$rootScope.globals.currentUser.lang;
           
            var url='../api/save-resource-form/'+formType+'/'+resourceId+'/'+lang+'/';
            var deferred = this.$q.defer();
            var instance=this;
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: widgets
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                                            
                       
                       instance.cache.getResourceForm[resourceId +'_'+formType+'_'+lang].widgets=data.data.formData;
                       deferred.resolve({data: instance.cache.getResourceForm[resourceId +'_'+formType+'_'+lang],msg:data.data.msg,version:data.data.version,updateForm:data.data.updateForm,msgType:data.data.msgType,new_items:data.data.new_items,status:data.status});
                        
                    
                      
                    } else {
                    
                   
                    deferred.reject({msg:'Save dataset form failed ! '+data.status+' '+data.data,status:data.status});
          
                    }
                },function (data) {

                    deferred.reject({msg:'Save dataset form failed ! '+data.status+' '+data.data,status:data.status});


                });
                
                 return deferred.promise;
        };
   
/*MIGOR     
//**********************************************************
//           GET FILES DATA
//**********************************************************      
^api/ ^files/(?P<id>.+)/$ [name='Files-list']
*/
	getFilesData  (resourceDefId,resourceId,lang) {
    
          var http_method="GET";
          
		  var url='../api/files/'+resourceDefId+'/'+resourceId+'/';
		  
            var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
            })
                .then(function (data) {
                    console.log(data);

                    if (data.status === 200) {
                     
                    
                       deferred.resolve({data: data.data,status:data.status});
                      
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                 
                      
                    } else {
                       deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});

                      
                        //console.log(data);
                    }
                },function (data) {

                   deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});

                });
                   return deferred.promise;
        };
		
  //**********************************************************
	//           DOWNLOAD FILE
	//**********************************************************      
  downloadFile  (fileId,resourceId) {
    
          var http_method="GET";
          
          var url='../api/download-file/'+fileId+'/'+resourceId+'/';
          var deferred = this.$q.defer();
          
          /*
           
           this.$http.defaults.headers.common['Authorization'] = "Token 54cbe008c9454f26acf9ca8b3355db186c4f37fc";
           var url='https://dev.katalyo.com/api/download-file/'+fileId+'/'+resourceId+'/';
            
              
              fetch('https://dev.katalyo.com/api/download-file/1/342/', 
                {
                  method: "GET",
                  headers: {         
                  //"Authorization": authdata    
                    "Authorization": "Token 54cbe008c9454f26acf9ca8b3355db186c4f37fc"      
                  }
                }).then(function(response) {
                   
                  response.status     //=> number 100–599
                  response.statusText //=> String
                  response.headers    //=> Headers
                  response.url        //=> String
                    deferred.resolve({data:data.data,status:data.status});
                  console.log(response);
                }, function(error) {
                    
                  error.message 
                })
              
            */  
            this.$http({
                method: http_method,
                url: url,
                //headers: { 'Content-Type': 'application/json' },
                responseType: 'arraybuffer'
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                      // deferred.resolve({msg: 'Database synced !',status:data.status});
                       deferred.resolve({data:data.data,status:data.status});

                    } else {
                      
                   
                     deferred.reject({msg: 'File download failed!',status:data.status});
                 //  $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
             
                    }
                },function (data) {

                    deferred.reject({msg: 'File download failed!',status:data.status});

                });
                   return deferred.promise;
        };		        
//**********************************************************
	//           DOWNLOAD FILE 
	//**********************************************************      
  previewFile  (fileId) {
    
          var http_method="GET";
          
          var url='../api/preview-file/'+fileId+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                //headers: { 'Content-Type': 'application/json' },
                responseType: 'arraybuffer'
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                      // deferred.resolve({msg: 'Database synced !',status:data.status});
                       deferred.resolve({data:data,status:data.status});

                    } else {
                      
                   
                     deferred.reject({msg: 'File download failed!',status:data.status});
                 //  $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
             
                    }
                },function (data) {

                    deferred.reject({msg: 'File download failed!',status:data.status});

                });
                   return deferred.promise;
        };		        
  
//*********************************************************
//           IMPORT  RESOURCE
//*********************************************************    
  importResource  (fileId, resourceId, mappingsId) {
    
          var http_method="GET";
          var url='../api/import-resource/'+fileId+'/'+resourceId+'/'+mappingsId+'/';
          var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
    
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 201) {
                      
                       deferred.resolve({data:data,status:data.status});
                       
                    } else {  
                     deferred.reject({msg: 'Import resource failed!',status:data.status});  
                    }
                },function (data) {

                    deferred.reject({msg: 'Import resource failed! '+ data.msg,status:data.status});

                });
                   return deferred.promise;
    };		
        

 //**********************************************************
	//           GET RESOURCE DATA
	//**********************************************************      
  getResourceData  (resourceId,taskId,formType,lang) {
    
          var http_method="GET";
          
          var url='../api/get-resource-data/'+resourceId+'/'+taskId+'/'+formType+'/'+lang+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                //data: $scope.dashboard.widgets
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                     // $scope.dashboard.widgets = data;

                       deferred.resolve({data: data.data.data,columnsDef: data.columnsDef,status:data.status});
                      
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                 
                      
                    } else {
                       deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});

                      
                        //console.log(data);
                    }
                },function (data) {

                     deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});


                });
                   return deferred.promise;
        };
  //**********************************************************
	//           GET RESOURCE DATA PAGINATED
  //**********************************************************      
  getResourceDataPaginated  (resourceId,url_next,url_prev,new_page,page_size) {
    
          var http_method="GET";
            var lang=this.$rootScope.globals.currentUser.lang;       
          var url='../api/get-resource-data-paginated/'+resourceId+'/'+lang+'/';

          if (new_page!="" && new_page!=undefined)
          {
            url = url+'?page='+new_page;
            if (page_size!="" && page_size!=undefined)
            {
            url = url+'&page_size='+page_size;
            
            }
          }
         
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                        //console.log(new Date());
                        deferred.resolve({data: data.data,status:data.status});
                      
                                         
                    } else {
                        deferred.reject({msg: "Get failed ! "+data.status+" "+data.data,status:data.status});
                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: "Get failed ! "+data.status+" "+data.data,status:data.status});

                });
                   return deferred.promise;
        };
  //**********************************************************
	//           GET RESOURCE DATA PAGINATED FILTER
  //**********************************************************      
  getResourceDataPaginatedFilter  (resourceId,url_next,url_prev,new_page,page_size,lang,filter,form_layout) {
    
          var http_method="POST";
          
                  
          var url='../api/get-resource-data-paginated-filter/'+resourceId+'/'+lang+'/';

          if (new_page!="" && new_page!=undefined)
          {
            url = url+'?page='+new_page;
            if (page_size!="" && page_size!=undefined)
            {
            url = url+'&page_size='+page_size;
            
            }
          }
         
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                 data: {'filter':filter,'form':form_layout},
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200 || status === 201) {
                        //console.log(new Date());
                        deferred.resolve({data: data.data,status:data.status});
                      
                                         
                    } else {
                        deferred.reject({msg: "Get failed ! "+data.status+" "+data.data,status:data.status});
                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: "Get failed ! "+data.status+" "+data.data,status:data.status});

                });
                   return deferred.promise;
        };
  //**********************************************************
	//           GET RESOURCE DATA PAGINATED FILTER
  //**********************************************************      
  getResourceDataPaginatedAuto  (resourceId,url_next,url_prev,new_page,page_size,lang,presentationId,taskInstanceId,formType) {
    
          var http_method="GET";
          
                  
          var url='../api/get-resource-data-paginated-auto/'+resourceId+'/'+presentationId+'/'+taskInstanceId+'/'+formType+'/'+lang+'/';

          if (new_page!="" && new_page!=undefined)
          {
            url = url+'?page='+new_page;
            if (page_size!="" && page_size!=undefined)
            {
            url = url+'&page_size='+page_size;
            
            }
          }
         
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200 || status === 201) {
                        //console.log(new Date());
                        deferred.resolve({data: data.data,status:data.status});
                      
                                         
                    } else {
                        deferred.reject({msg: "Get failed ! "+data.status+" "+data.data,status:data.status});
                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: "Get failed ! "+data.status+" "+data.data,status:data.status});

                });
                   return deferred.promise;
        };
  //**********************************************************
	//           GET RESOURCE COLUMNS
  //**********************************************************      
  getResourceColumns  (resourceId,taskId,formType,lang) {
    
          var http_method="GET";
          
                  
          var url='../api/get-resource-columns/'+resourceId+'/'+taskId+'/'+formType+'/'+lang+'/';

         
          var deferred = this.$q.defer(); 
            var gotoServer=false;
           
      if (this.cache['getResourceColumns'] !==undefined)
      {
         if(this.cache.getResourceColumns[resourceId+'_'+taskId+'_'+formType+'_'+lang] !==undefined)
         {
            deferred.resolve({data:  this.cache.getResourceColumns[resourceId+'_'+taskId+'_'+formType+'_'+lang],status:200});
         }
         else
         {
           this.cache['getResourceColumns'][resourceId+'_'+taskId+'_'+formType+'_'+lang] = {};
           gotoServer=true; 
         }
      } else
      {
         this.cache['getResourceColumns'] = {};
         this.cache['getResourceColumns'][resourceId+'_'+taskId+'_'+formType+'_'+lang] = {};
         gotoServer=true;
      }  
       if (gotoServer)
       {
           var instance = this;
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                        //console.log(new Date());
                        instance.cache['getResourceColumns'][resourceId+'_'+taskId+'_'+formType+'_'+lang] = data.data;
                        deferred.resolve({data: data.data,status:data.status});
                      
                                         
                    } else {
                        deferred.reject({msg: "Get columns failed ! "+data.status+" "+data.data,status:data.status});
                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: "Get columns failed ! "+data.status+" "+data.data,status:data.status});

                });
       }
                   return deferred.promise;
        };
  //**********************************************************
	//           GET RESOURCE DATA
	//**********************************************************      
  getResourceDataModel  (resourceId,taskId,modelId,formType,lang) {
    
          var http_method="GET";
          
          var url='../api/get-resource-data-model/'+resourceId+'/'+taskId+'/'+modelId+'/'+formType+'/'+lang+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                //data: $scope.dashboard.widgets
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                     // $scope.dashboard.widgets = data;

                       deferred.resolve({data: data.data.data,columnsDef: data.columnsDef,status:data.status});
                      
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                 
                      
                    } else {
                       deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});

                      
                        //console.log(data);
                    }
                },function (data) {

                     deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});


                });
                   return deferred.promise;
        };
  //**********************************************************
	//           GET RESOURCE DATA FILTERED
	//**********************************************************      
  getResourceDataFiltered  (resourceId,taskId,formType,lang,filter) {
    
          var http_method="POST";
          
          var url='../api/get-resource-data-filtered/'+resourceId+'/'+taskId+'/'+formType+'/'+lang+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: filter
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                     // $scope.dashboard.widgets = data;

                       deferred.resolve({data: data.data.data,columnsDef: data.columnsDef,status:data.status});
                      
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                 
                      
                    } else {
                        deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});

                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                    deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});


                });
                   return deferred.promise;
        };
 
 //**********************************************************
	//           GET RESOURCE DATA DIRECT FILTER
	//**********************************************************      
  getResourceDataDirectFilter  (resourceId,taskId,formType,lang,filter) {
    
          var http_method="POST";
          
          var url='../api/get-resource-data-direct-filter/'+resourceId+'/'+taskId+'/'+formType+'/'+lang+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: filter
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                     // $scope.dashboard.widgets = data;

                       deferred.resolve({data: data.data.data,columnsDef: data.data.columnsDef,status:data.status});
                      
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                 
                      
                    } else {
                        deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});

                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                    deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});


                });
                   return deferred.promise;
        };
 
 
  //**********************************************************
	//           GET RESOURCE DATA RELATED
	//**********************************************************      
  getResourceDataRelated  (datasetId,recordId,relatedId,taskId,modelId,formType,lang) {
    
          var http_method="POST";
          
          var url='../api/get-resource-data-related/'+datasetId+'/'+recordId+'/'+relatedId+'/'+taskId+'/'+modelId+'/'+formType+'/'+lang+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

               // data: filter
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                     // $scope.dashboard.widgets = data;

                       deferred.resolve({data: data.data.data,columnsDef: data.columnsDef,status:data.status});
                      
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                 
                      
                    } else {
                        deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});

                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                    deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});


                });
                   return deferred.promise;
        };
  
  //**********************************************************
	//           GET RESOURCE DATA WITH RELATED
	//**********************************************************      
  getResourceDataWithRelated  (datasetId,relatedId,recordId,taskId,modelId,formType,lang) {
    
          var http_method="POST";
          
          var url='../api/get-resource-data-with-related/'+datasetId+'/'+relatedId+'/'+recordId+'/'+taskId+'/'+modelId+'/'+formType+'/'+lang+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

               // data: filter
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                     // $scope.dashboard.widgets = data;

                       deferred.resolve({data: data.data.data, m2m:data.m2m, columnsDef: data.columnsDef,status:data.status});
                      
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                 
                      
                    } else {
                        deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});

                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                    deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});


                });
                   return deferred.promise;
        };
        
  
  //**********************************************************
	//           GET DATASET MAPPING HEAD
  //**********************************************************      
  getMappingPackages  (fromDs,toDs,lang) {
    
         if (fromDs==undefined) fromDs=0;
         if (toDs==undefined) toDs=0;
         
          var http_method="GET";
          
          var url='../api/get-dataset-mapping-head/'+fromDs+'/'+toDs+'/'+lang+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

               // data: filter
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                     // $scope.dashboard.widgets = data;

                       deferred.resolve({data: data.data, status:data.status});
                      
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                 
                      
                    } else {
                        deferred.reject({msg: data,status:data.status});

                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                    deferred.reject({msg:data,status:data.status});


                });
                   return deferred.promise;
        };
   //**********************************************************
	//           GET DATASET TRANSFORM HEAD
  //**********************************************************      
  getTransformPackages  (lang) {
    
          var http_method="GET";
          
          var url='../api/get-dataset-transform-head/'+lang+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

               // data: filter
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                     // $scope.dashboard.widgets = data;

                       deferred.resolve({data: data.data, status:data.status});
                      
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                 
                      
                    } else {
                        deferred.reject({msg: data,status:data.status});

                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                    deferred.reject({msg:data,status:data.status});


                });
                   return deferred.promise;
        };
   
  //**********************************************************
	//           GET RESOURCE FIELDS
  //**********************************************************      
  getResourceFields  (resourceId,lang = $rootScope.globals.currentUser.lang ) {
    
          var http_method="GET";
          var url='../api/get-resource-fields/'+resourceId+'/'+lang+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

               // data: filter
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                     // $scope.dashboard.widgets = data;

                       deferred.resolve({data: data.data, status:data.status});
                      
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                 
                      
                    } else {
                        deferred.reject({msg: data.data,status:data.status});

                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                    deferred.reject({msg:data.data,status:data.status});


                });
                   return deferred.promise;
        };     
   //**********************************************************
	//           GET DATASET MAPPINGS
  //**********************************************************      
  getDatasetMappings  (mappingId,lang) {
    
          var http_method="GET";
          
          var url='../api/get-dataset-mapping-detail/'+mappingId+'/'+lang+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

               // data: filter
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                     // $scope.dashboard.widgets = data;

                       deferred.resolve({data: data.data, status:data.status});
                      
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                 
                      
                    } else {
                        deferred.reject({msg: data,status:data.status});

                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                    deferred.reject({msg:data,status:data.status});


                });
                   return deferred.promise;
        };     
        //**********************************************************
	//           GET DATASET MAPPINGS
  //**********************************************************      
  saveDatasetMappingDetails  (mappings,mappingId) {
    
          var http_method="POST";
          
          var url='../api/save-dataset-mapping-details/'+mappingId+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: mappings
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                     // $scope.dashboard.widgets = data;

                       deferred.resolve({data, status});
                      
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                 
                      
                    } else {
                        deferred.reject({data,status});

                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                    deferred.reject({data,status});


                });
                   return deferred.promise;
        };     
//**********************************************************
//        SAVE DATASET MAPPING HEAD
//**********************************************************      
  saveDatasetMappingHead  (mappings,mappingId,lang) {
    
          var http_method="POST";
          
          var url='../api/save-dataset-mapping-head/'+mappingId+'/'+lang+'/';
          var deferred = this.$q.defer(); 
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
                data: mappings
            })
                .then(function (data) {
                    console.log(data);
                    if (data.status === 200) {
                       deferred.resolve({data, status});  
                    } else {
                        deferred.reject({data,status});
                        console.log(data);
                    }
                },function (data) {
                    deferred.reject({data,status});
                });
                   return deferred.promise;
        }; 
 
//**********************************************************
//        SAVE TRANSFORM HEAD
//**********************************************************      
  saveDatasetTransformHead  (transforms,transformId,lang) {
    
          var http_method="POST";
          
          var url='../api/save-dataset-transform-head/'+transformId+'/'+lang+'/';
          var deferred = this.$q.defer(); 
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
                data: transforms
            })
                .then(function (data) {
                    console.log(data);
                    if (data.status === 200) {
                       deferred.resolve({data, status});  
                    } else {
                        deferred.reject({data,status});
                        console.log(data);
                    }
                },function (data) {
                    deferred.reject({data,status});
                });
                   return deferred.promise;
        };  
   //**********************************************************
	//           GET TRANSFORM FIELDS
  //**********************************************************      
  getTransformFields  (transformId) {
    
          var http_method="GET";
          
          var url='../api/get-dataset-transform-details/'+transformId+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

               // data: filter
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                     // $scope.dashboard.widgets = data;

                       deferred.resolve({data, status});
                      
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                 
                      
                    } else {
                        deferred.reject({data,status});

                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                    deferred.reject({data,status});


                });
                   return deferred.promise;
        };
     //**********************************************************
	//           SAVE TRANSFORM FIELDS
  //**********************************************************      
  saveTransformFields  (transformations,transformId) {
    
          var http_method="POST";
          
          var url='../api/save-dataset-transform-details/'+transformId+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: transformations
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                     // $scope.dashboard.widgets = data;

                       deferred.resolve({data, status});
                      
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                 
                      
                    } else {
                        deferred.reject({data,status});

                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                    deferred.reject({data,status});


                });
                   return deferred.promise;
        };     
  //**********************************************************
	//           GET Inititate widgets
	//**********************************************************      
  getFormWidgets  (resource_id,task_id,presentation_id,type,lang) {
    
          var http_method="GET";
          
          if (presentation_id==undefined || presentation_id==null) presentation_id=0;
          
          var url='../api/get-form-widgets/'+resource_id+'/'+task_id+'/'+presentation_id+'/'+type+'/'+lang+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

               // data: filter
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                     // $scope.dashboard.widgets = data;

                       deferred.resolve({data: data.data,status:data.status});
                      
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                 
                      
                    } else {
                        deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});

                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                    deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});


                });
                   return deferred.promise;
        };
  //**********************************************************
	//           SAVE RESOURCE DATA
	//**********************************************************      
  saveResourceData  (resourceId,resourceData) {
    
          var http_method="POST";
          
          var url='../api/save-resource-data/'+resourceId+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: resourceData
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200 || data.status === 201) {
                  
                   
                            deferred.resolve({msg: 'New record saved successfully !',status:data.status});
                
                 
                       
                      
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                 
                      
                    } else {
                       deferred.reject({msg:'Save failed ! '+data.status+' '+data.data,status:data.status});

                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg:'Save failed ! '+data.status+' '+data.data,status:data.status});


                });
                   return deferred.promise;
        };
    
    //**********************************************************
	//           SAVE RESOURCE DATA
	//**********************************************************      
  deleteDatasetRecord  (resourceDefId,resourceId) {
    
          var http_method="POST";
          
          var url='../api/delete-dataset-record/'+resourceDefId+'/'+resourceId+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                  
                   
                            deferred.resolve({data:data,msg: data.msg,status:data.status});

                    } else {
                       deferred.reject({data:data,msg:data.msg,status:data.status});

                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg:data,status:data.status});


                });
                   return deferred.promise;
        };
    
       //**********************************************************
	//           GET RESOURCE PARAMS
	//**********************************************************      
  GetResourceParams  () {
    
          var http_method="GET";
          
          var url='../api/get-resource-params/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                  
                   
                            deferred.resolve({data:data.data,status:data.status});

                    } else {
                       deferred.reject({data:data.data,status:data.status});

                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({data:data.data,status:data.status});


                });
                   return deferred.promise;
        };
        
      //**********************************************************
	//           GET RESOURCE SUBSCRIPTIONS
	//**********************************************************      
  GetResourceSubscriptions  (subscriptionType) {
    
          var http_method="GET";
          
          var url='../api/resource-subscriptions/'+subscriptionType+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                  
                   
                            deferred.resolve({data:data.data,status:data.status});

                    } else {
                       deferred.reject({data:data.data,status:data.status});

                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({data:data.data,status:data.status});


                });
                   return deferred.promise;
        };
    
       //**********************************************************
	//           MANAGE RESOURCE SUBSCRIPTIONS
	//**********************************************************      
  ManageResourceSubscriptions  (resource,subscriptionType,actionType) {
    
          var http_method="POST";
          
          var url='../api/resource-subscriptions/'+subscriptionType+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
                data: { 'resource': resource,'action':actionType}
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                  
                   
                            deferred.resolve({data:data.data,status:data.status});

                    } else {
                       deferred.reject({data:data.data,status:data.status});

                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({data:data.data,status:data.status});


                });
                   return deferred.promise;
        };
        
   prepareResourceWidgetData  (rows,resourceRecordId)
    {
      
      var resourceData = {};
      var value="",fieldId="";
      if (resourceRecordId>0)
      {
        resourceData['id'] = {type:'resourceId', value: resourceRecordId};
      }
     for (var i=0;i<rows.length;i++) {
              if ('layout' in rows[i])
               {
                   for (var j=0;j<rows[i].layout.length;j++) {
                    if ('layout' in rows[i].layout[j])
                    {
                     for (var l=0;l<rows[i].layout[j].layout.length;l++) { 
                      
                      
                      if(rows[i].layout[j].layout[l].type=='resourceid' && rows[i].layout[j].layout[l].sItemValue!=null && resourceRecordId==-1)
                       {
                               
                          resourceData['id'] = {type:'resourceId', value: rows[i].layout[j].layout[l].sItemValue};                     
                       }
                      if ((rows[i].layout[j].layout[l].ItemId!=null && rows[i].layout[j].layout[l].sItemValue!=undefined && rows[i].layout[j].layout[l].sItemValue!=null && !rows[i].layout[j].layout[l].noUpdate) || (rows[i].layout[j].layout[l].ItemId!=null && rows[i].layout[j].layout[l].type=='resource'))
                      {
                         
                       fieldId='Field'+rows[i].layout[j].layout[l].ItemId;
                       value = rows[i].layout[j].layout[l].sItemValue;
                       if (rows[i].layout[j].layout[l].Dbtype=='foreignkeydefinition') {
                          fieldId=fieldId+'_id';//code
                          if (rows[i].layout[j].layout[l].type=='user')
                          {
                            value = rows[i].layout[j].layout[l].sItemValue;
                            }
                            else
                            {
                              
                             if (rows[i].layout[j].layout[l].sItemValue!=undefined)
                             {
                              value= rows[i].layout[j].layout[l].sItemValue.id;
                             }
                             
                            }
                          if (value!=""  && value!=undefined)
                          {
                            resourceData[fieldId] = {type:rows[i].layout[j].layout[l].type, value: value };
                          }
                       }
                       else if(rows[i].layout[j].layout[l].type=='resource')
                       {
                          resourceData[fieldId]={type:rows[i].layout[j].layout[l].type,value:{resourceDefId: rows[i].layout[j].layout[l].Related,resourceId:rows[i].layout[j].layout[l].Value }}
                       }
                       else if(rows[i].layout[j].layout[l].type=='date')
                       {
                        if (rows[i].layout[j].layout[l].useSystemDate)
                        {
                          resourceData[fieldId]={type:'systemdate',value:rows[i].layout[j].layout[l].sItemValue}
                        }
                        else
                        {
                          resourceData[fieldId]={type:rows[i].layout[j].layout[l].type,value:rows[i].layout[j].layout[l].sItemValue}
                        }
                       }
                       else
                       {
                         if (value!="" && value!=undefined)
                          {
                            resourceData[fieldId] = {type:rows[i].layout[j].layout[l].type, value: value }
                          }
                       }
                       
                      }

                    }
                  }
                }
               }
              }
               
               return resourceData;
      
    };

  /*MIGOR     
//**********************************************************
//           GET FILES DATA
//**********************************************************      
^api/ ^files/(?P<id>.+)/$ [name='Files-list']
*/
	getFilesData1  (resourceId,lang) {
    
          var http_method="GET";
          
		  var url='../api/files/'+resourceId+'/';
		  
            var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
            })
                .then(function (data) {
                    console.log(data);

                    if (data.status === 200) {
                     
                      // deferred.resolve({data: data.data.data,columnsDef: data.columnsDef,status:data.status});
                       deferred.resolve({data: data.data,status:data.status});
                      
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                 
                      
                    } else {
                       deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});

                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                    deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});

                });
                   return deferred.promise;
        };
		
		// MIGOR START

    //**********************************************************
	//           MIGOR - UPDATE FILE DATA
	//**********************************************************      
          
     fileMetaUpdate (fileId,fileMetaId,taskInstanceId,widgetId,prevTaskId,parentDatasetDefId,parentDatasetId,fileResourceData) {
    
          var http_method="POST";
          
          var url='../api/file-meta-data-update/';
            var deferred = this.$q.defer();
            if (prevTaskId==undefined) prevTaskId=0;
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
                data: {'fileId':fileId,'fileMetaId':fileMetaId,'widgetId':widgetId,'taskInstanceId':taskInstanceId,'prevTaskId':prevTaskId,'parentDatasetDefId':parentDatasetDefId,'parentDatasetId':parentDatasetId,'fileResourceData':fileResourceData}
                
            })
                .then(function (data) {
                   // console.log(data);

                    if (data.status === 200) {                   
                     
                       deferred.resolve({data: data.data,status:data.status});
 
                   
                      
                    } else {
                      deferred.reject({msg:'Save failed ! '+data.status+' '+data.data,status:data.status});
                    //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                  deferred.reject({msg:'Save failed ! '+data.status+' '+data.data,status:data.status});

                });
                
                 return deferred.promise;
        };
       
// MIGOR END

	getCodes (code_id,language){
             var codeIndex=-1;
             if (code_id != undefined) {
              var deferred = this.$q.defer();                   
              var pos = listOfCodesById.map(function(e) { return e.unique_id; }).indexOf(code_id+language);
              if (pos<0){
				  //if  not found - download
			
      
			this.$http({
                method: 'GET',
                url: '../api/get-codes-detail-byidlang/'+ code_id+'/'+language+'/',
                headers: { 'Content-Type': 'application/json' },

               // data: $scope.resource
             
            })
                .then(function (data) {

                    if (data.status === 200) {
              
                      var retrivedList = {unique_id: code_id+language, id: code_id,lang: language, codeList: data};
              
          					  listOfCodesById.push(retrivedList);
                      codeIndex=listOfCodesById.length-1;
                      deferred.resolve(listOfCodesById[codeIndex].codeList, status);
                      
                    } else {
                        deferred.reject(data);
                    }
                },function (data) {
                    
                    //console.log("ERROR!!!-"+status);
                    deferred.reject(data);
                });
				
              } else {
                codeIndex=pos;
                deferred.resolve(listOfCodesById[codeIndex].codeList, 200);
              }
            };
	
          return deferred.promise;
		  };
		  

}
 export default ResourcesDataService;